import store from '../../store/index';

const getFatRow = (data) => {
//TODO: refactor this code
  function fatRowGenerator(data) {
    console.log('FATROWGENERATOR', data)
    const docpList = store.getters['folderModule/foldersDocpListGetter'];
    let currentFolderDocp = null;
    const canResolveRef = (value, dataObj) => {
      return typeof value === 'string' && dataObj[value] !== undefined;
    };
    const resolveIndex = (uconst, dataObj, records) => {
      let idx = dataObj[uconst];
      if (typeof idx !== 'number' && idx !== undefined) {
        const parts = String(idx).split(/\D+/);
        idx = parseInt(parts[0], 10);
      }
      if (!Number.isInteger(idx)) {
        return undefined;
      }
      if (records[idx]?.id === uconst) {
        return idx;
      }
      // Some payloads can be off by a few rows (including landing on `_path` rows).
      // Search in a tight window to recover the correct row safely.
      for (let offset = 1; offset <= 4; offset++) {
        if (records[idx - offset]?.id === uconst) return idx - offset;
        if (records[idx + offset]?.id === uconst) return idx + offset;
      }
      return idx;
    };
    if (!data?.output?.data?.records || data?.output?.data?.records?.length === 0) {
      return [];
    }
    const finalData = [];
    if (docpList !== null && docpList[data.folder] !== undefined) {
      currentFolderDocp = docpList[data.folder];
      const records = JSON.parse(JSON.stringify(data.output.data.records));
      const dataObj = records[records.length - 1];
      const dataStart = dataObj['dataStart']
      const dataEnd = dataObj['dataEnd']
      const folderName = Object.keys(records[dataStart])[0]
      for (let i = dataStart; i < dataEnd; i++) {
        const uconst = records[i][folderName];
        const index = resolveIndex(uconst, dataObj, records);
        if (index === undefined) continue;
        const record = JSON.parse(JSON.stringify(records[index]));
        for (let j = 0; j < currentFolderDocp.length; j++) {
          const keys = Object.keys(currentFolderDocp[j])
          if (keys.length > 1) {
            const docpName = currentFolderDocp[j].name;
            const isMultiple = currentFolderDocp[j].is_multiple;
            if (record[docpName] !== null && record[docpName] !== undefined) {
              if (isMultiple) {
                for (let key = 0; key < record[docpName].length; key++) {
                  if (record[docpName][key] !== null && record[docpName][key] !== undefined) {
                    const docpUconst = record[docpName][key];
                    const docpIndex = resolveIndex(docpUconst, dataObj, records);
                    if (docpIndex !== undefined) {
                      for (const docpKey in records[docpIndex]) {
                        if (records[docpIndex][docpKey] !== null && Array.isArray(records[docpIndex][docpKey])) {
                          if (records[docpIndex][docpKey].length === 1) {
                            const docpUconst2 = records[docpIndex][docpKey][0];
                            if (canResolveRef(docpUconst2, dataObj)) {
                              const docpIdx = resolveIndex(docpUconst2, dataObj, records);
                              if (docpIdx !== undefined) {
                                records[docpIndex][docpKey][0] = JSON.parse(JSON.stringify(records[docpIdx]));
                              }
                            }
                          } else {
                            for (let m = 0; m < records[docpIndex][docpKey].length; m++) {
                              for (const docpKey2 in records[docpIndex][docpKey][m]) {
                                if (records[docpIndex][docpKey][m][docpKey2] !== null && Array.isArray(records[docpIndex][docpKey][m][docpKey2])) {
                                  const docpKeyUconst = records[docpIndex][docpKey][m][docpKey2][0];
                                  if (canResolveRef(docpKeyUconst, dataObj)) {
                                    const docpKeyIdx = resolveIndex(docpKeyUconst, dataObj, records);
                                    if (docpKeyIdx !== undefined) {
                                      records[docpIndex][docpKey][m][docpKey2][0] = JSON.parse(JSON.stringify(records[docpKeyIdx]));
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                      record[docpName][key] = JSON.parse(JSON.stringify(records[docpIndex]));
                    }
                  }
                }
              } else {
                const docpUconst = record[docpName][0];
                const docpIndex = resolveIndex(docpUconst, dataObj, records);
                if (docpIndex !== undefined) {
                  for (const docpKey in records[docpIndex]) {
                    if (docpKey === 'addresses') {
                      if (records[docpIndex][docpKey] !== null) {
                      }
                    }
                    if (records[docpIndex][docpKey] !== null && Array.isArray(records[docpIndex][docpKey])) {
                      if (records[docpIndex][docpKey].length === 1) {
                        const docpUconst2 = records[docpIndex][docpKey][0];
                        if (canResolveRef(docpUconst2, dataObj)) {
                          const docpIdx = resolveIndex(docpUconst2, dataObj, records);
                          if (docpIdx !== undefined) {
                            records[docpIndex][docpKey][0] = JSON.parse(JSON.stringify(records[docpIdx]));
                          }
                        } else {
                          for (let m = 0; m < records[docpIndex][docpKey].length; m++) {
                            for (const docpKey2 in records[docpIndex][docpKey][m]) {
                              if (records[docpIndex][docpKey][m][docpKey2] !== null && Array.isArray(records[docpIndex][docpKey][m][docpKey2])) {
                                const docpKeyUconst = records[docpIndex][docpKey][m][docpKey2][0];
                                if (canResolveRef(docpKeyUconst, dataObj)) {
                                  const docpKeyIdx = resolveIndex(docpKeyUconst, dataObj, records);
                                  if (docpKeyIdx !== undefined) {
                                    records[docpIndex][docpKey][m][docpKey2][0] = JSON.parse(JSON.stringify(records[docpKeyIdx]));
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else {
                        for (let m = 0; m < records[docpIndex][docpKey].length; m++) {
                          for (const docpKey2 in records[docpIndex][docpKey][m]) {
                            if (records[docpIndex][docpKey][m][docpKey2] !== null && Array.isArray(records[docpIndex][docpKey][m][docpKey2])) {
                              const docpKeyUconst = records[docpIndex][docpKey][m][docpKey2][0];
                              if (canResolveRef(docpKeyUconst, dataObj)) {
                                const docpKeyIdx = resolveIndex(docpKeyUconst, dataObj, records);
                                if (docpKeyIdx !== undefined) {
                                  records[docpIndex][docpKey][m][docpKey2][0] = JSON.parse(JSON.stringify(records[docpKeyIdx]));
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  record[docpName][0] = JSON.parse(JSON.stringify(records[docpIndex]));
                }
              }
            }
          } else {
            const detailName = keys[0];
            if (record[detailName] !== null && record[detailName] !== undefined) {
              for (let k = 0; k < currentFolderDocp[j][detailName].length; k++) {
                const detailDocpName = currentFolderDocp[j][detailName][k].name;
                if (Array.isArray(record)) {}
                for (let l = 0; l < record[detailName].length; l++) {
                  if (record[detailName][l][detailDocpName] !== null) {
                    const detailUconst = record[detailName]?.[l]?.[detailDocpName]?.[0];
                    const detailIndex = resolveIndex(detailUconst, dataObj, records);
                    if (detailIndex !== undefined) {
                      for (const detailDocpKey in records[detailIndex]) {
                        if (records[detailIndex][detailDocpKey] !== null && Array.isArray(records[detailIndex][detailDocpKey])) {
                          if (records[detailIndex][detailDocpKey].length === 1) {
                            const detailUconst2 = records[detailIndex][detailDocpKey][0];
                            if (canResolveRef(detailUconst2, dataObj)) {
                              const detailIdx = resolveIndex(detailUconst2, dataObj, records);
                              if (detailIdx !== undefined) {
                                records[detailIndex][detailDocpKey][0] = JSON.parse(JSON.stringify(records[detailIdx]));
                              }
                            }
                          } else {
                            for (let m = 0; m < records[detailIndex][detailDocpKey].length; m++) {
                              for (const docpKey in records[detailIndex][detailDocpKey][m]) {
                                if (records[detailIndex][detailDocpKey][m][docpKey] !== null && Array.isArray(records[detailIndex][detailDocpKey][m][docpKey])) {
                                  const docpKeyUconst = records[detailIndex][detailDocpKey][m][docpKey][0];
                                  if (canResolveRef(docpKeyUconst, dataObj)) {
                                    const docpKeyIdx = resolveIndex(docpKeyUconst, dataObj, records);
                                    if (docpKeyIdx !== undefined) {
                                      records[detailIndex][detailDocpKey][m][docpKey][0] = JSON.parse(JSON.stringify(records[docpKeyIdx]));
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                      record[detailName][l][detailDocpName][0] = JSON.parse(JSON.stringify(records[detailIndex]));
                    }
                  }
                }
              }
            }
          }
        }
        finalData.push(JSON.parse(JSON.stringify(record)));
      }
    }
    console.log('FINALDATA', finalData)
    return finalData;
  }

  return { fatRowGenerator };
};

export default getFatRow;
